import * as yup from 'yup';
import { TFunction } from 'i18next';
import { descriptionValidation } from 'utils/yup';

export const CreateForm = (t: TFunction): any => {
  return yup.object().shape({
    name: descriptionValidation(t),
  });
};

export const EditForm = (t: TFunction): any =>
  yup.object().shape({
    name: descriptionValidation(t),
  });
